"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Delay = void 0;
var _react = require("react");
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const Delay = ({
  delay,
  skeleton,
  children
}) => {
  const [ready, setReady] = (0, _react.useState)(false);
  (0, _react.useEffect)(() => {
    var timer = setTimeout(() => {
      setReady(true);
    }, delay);
    return () => {
      clearInterval(timer);
    };
  }, [delay]);
  return ready ? children : skeleton;
};
exports.Delay = Delay;
Delay.defaultProps = {
  delay: 0,
  skeleton: null
};
Delay.propTypes = {
  delay: _propTypes.default.number,
  skeleton: _propTypes.default.node
};